import apiUrl from '../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import approval from './approvalflow-tab/approval';
import module from './approvalflow-tab/module';
// import roles from './approvalflow-tab/roles';

export default {
  name: 'approvalflow',
  components: {
    VueElementLoading,
    module,
    Paginate,
    approval,
    // roles
  },
  props: [],
  data: function() {
    return {
      selectedTab : "module",
      admin : '',
      masterData : {},
      isLoading:false
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email;
    let findAdminKey = this.useremail.split('.');
    this.admin = findAdminKey[0];
    if(this.admin != 'admin'){
      this.tabChange();
    }
  },
  methods: {
    tabNavigation(value){
      this.selectedTab = value;
    },
    tabChange(){
      this.selectedTab = 'approval';
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/cargoclient/approvalflow/approvalflow.component.js